<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <section class="content-sectiton">
      <div class="container">
        <div class="alert custom-alert-danger" role="alert">
          <p>
            Invitation has expired!!
          </p>
        </div>
      </div><!-- .content-inner -->
    </section>
  </nb-layout-column>
</nb-layout>
